<template>
    <div class="snap-circle standard">
        <div class="circle">
            <div class="content">
                <div class="amount">{{ params.data }}</div>
                <div class="tendency" v-if="hasRecentSold">
                    <!--  more than the  0 -->
                    <div
                        class="up"
                        :class="[params.class ? params.class : '']"
                        v-if="params.status === 1 && !params.dataComing"
                    >
                        <span class="iconfont icon-trend-up"></span>
                        <span class="num">{{ params.changeNum }}</span>
                    </div>
                    <!--  less than  0 -->
                    <div
                        class="down"
                        :class="[params.class ? params.class : '']"
                        v-else-if="params.status === -1 && !params.dataComing"
                    >
                        <span class="iconfont icon-trend-down"></span>
                        <span class="num">{{ params.changeNum }}</span>
                    </div>
                    <!--  equal  0 -->
                    <div
                        class="no_data"
                        v-else-if="params.status === 0 && !params.dataComing"
                    >
                        <span>{{ params.changeNum }}</span>
                    </div>
                    <!-- 30-60 No listings sold during days  -->
                    <div class="no_data" v-else>
                        <span>{{ params.dataComing ? '' : '-' }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="sort">{{ params.title }}</div>
    </div>
</template>

<script>
export default {
    name: 'snap-circle',
    props: {
        params: Object,
        hasRecentSold: Boolean
    }
};
</script>

<style lang="scss">
.snap-circle.standard {
    width: 220px;
    margin: 0 auto;
    .circle {
        width: 100%;
        height: 220px;
        border-radius: 120px;
        border: solid 10px #f8f9fd;
        background-color: #ffffff;
        position: relative;
        .content {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -30px);
            .amount {
                font-family: var(--font-normal);
                font-size: 36px;
                line-height: 40px;
                color: var(--color-text);
                text-align: center;
                white-space: nowrap;
            }
            .tendency {
                margin-top: 10px;
            }
        }
        .tendency {
            margin-top: 10px;
            font-family: var(--font-normal);
            font-size: 24px;
            font-weight: bold;
            line-height: 1.25;
    
            .up,
            .down {
                display: flex;
                align-items: center;
                justify-content: center;
                .iconfont {
                    margin-right: 6px;
                }
            }
            .no_data {
                text-align: center;
            }
            .up {
                color: #96efb4;
                &.diff-color {
                    color: #ffb8b4;
                }
            }
            .down {
                color: #ffb8b4;
                &.diff-color {
                    color: #96efb4;
                }
            }
        }
    }
    .sort {
        margin-top: 20px;
        font-family: val(--font-normal);
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: var(--color-label);
    }
}

</style>
